import {Component, OnInit, Output, EventEmitter, OnDestroy, Input} from '@angular/core';
import { Subscription } from 'rxjs';
import { FormControl} from '@angular/forms';
import { MatOptionSelectionChange } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {LookupContractOpportunityAdvancedComponent} from '../lookup-contract-opportunity-advanced/lookup-contract-opportunity-advanced.component';
import {Opportunity, OpportunityContract, OpportunityContractLookupType} from '../../shared/domain/opportunity';
import {ItemSummaryOpportunityService} from '../../shared/opportunity/item-summary-opportunity.service';
import {ContractStatus} from '../../shared/domain/contract';

@Component({
  selector: 'lib-item-summary-lookup-contract',
  templateUrl: './lookup-contract.component.html',
  styleUrls: ['./lookup-contract.component.scss']
})
export class LookupContractComponent implements OnInit, OnDestroy {

  @Input() currentOpportunity: Opportunity;
  @Output() selectedContractEmitter = new EventEmitter();

  public selectedContract: OpportunityContract;
  public contractSearchParam: FormControl = new FormControl();
  public filteredContracts: OpportunityContract[] = [];
  public loadingContracts = false;
  public noContractsFound = false;

  private isUserSelectingContract = false;
  private contractSearchParamControlSubscription: Subscription;

  constructor(private opportunityService: ItemSummaryOpportunityService,
              private dialog: MatDialog) {
    this.subscribeContractSearchChange();
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.contractSearchParamControlSubscription) {
      this.contractSearchParamControlSubscription.unsubscribe();
    }
  }

  public onContractSelection(event: MatOptionSelectionChange) {
    this.selectedContract = null;
    this.isUserSelectingContract = true;
  }

  public getContractStageColor(contractStage: string): string {
    return ContractStatus.getContractStageColor(contractStage);
  }

  public getContractName(contract: OpportunityContract): string {
    if (contract) {
      return contract.salesHubContractNumber ? (contract.salesHubContractNumber + ' - ' + contract.legalName) : contract.legalName;
    } else {
      return '';
    }
  }

  public displayAdvancedSearchDialog(): void {
    this.filteredContracts = [];
    this.dialog.open(LookupContractOpportunityAdvancedComponent, {
      width: '100%',
      height: '100%',
      data: { lookupType: OpportunityContractLookupType.Contract,
              currentOpportunity:this.currentOpportunity},
      disableClose: true
    }).afterClosed().subscribe(contract => {
      if (contract) {
        this.noContractsFound = false;
        this.isUserSelectingContract = true;
        this.filteredContracts.push(contract);
        this.contractSearchParam.setValue(contract);
      }
    });
  }

  private loadContracts(searchParameter: string): void {
    this.loadingContracts = true;
    this.noContractsFound = false;
    this.filteredContracts = [];
    this.contractSearchParamControlSubscription = this.opportunityService.loadContractsForAutoComplete(searchParameter).subscribe(
      data => {
        this.filteredContracts = data as OpportunityContract[];
        this.filteredContracts = this.filteredContracts.filter( opportunity => opportunity.salesHubContractNumber !== this.currentOpportunity.contractNumber);
        this.loadingContracts = false;
        if (!this.filteredContracts || this.filteredContracts.length === 0) {
          this.noContractsFound = true;
        }
      });
  }

  private subscribeContractSearchChange(): void {
    this.contractSearchParam.valueChanges
      .pipe(debounceTime(1000),
        distinctUntilChanged())
      .subscribe(searchParameter => {
        this.selectedContract = null;
        if (!this.isUserSelectingContract) {
          this.loadContracts(searchParameter);
        } else {
          this.selectedContract = this.filteredContracts.length > 0 ? this.contractSearchParam.value : null;
          this.isUserSelectingContract = false;
          this.selectedContractEmitter.emit(this.selectedContract);
        }
      });
  }
}
